<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [batch]="false" [actions]="tableActions" (action)="onAction($event)"
  (changeBatch)="onChangeBatch($event)"></app-table>


<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>
